export const AUTH_TYPE_KEY_MAP = {
  EMAIL: "email",
  MOBILE: "mobile"
}